import React, { Component }  from 'react';
import Loading from '../loading';
import References from './references'; 
import InternalService from '../../services/internal-api';
import { splitImage } from '../../helpers/images';

import './specimens-list.css';

export default class Specimens extends Component {

  stampsData = new InternalService();

  componentDidMount() {
    const { scrollToElement, selection } = this.props;
    const elementId = `specimen${selection}`;
    if (scrollToElement) setTimeout(()=> scrollToElement(elementId), 1000);
  }

  handleSplitAndSend = async (imageUrl, id) => {
    const file = await this.imageUrlToFile(imageUrl, 'original.jpg');
    const [leftHalf, rightHalf] = await splitImage(file);
  
    this.stampsData.moveToNewType(id, leftHalf, rightHalf)
      .then(response => {
        const newRoute = `/type/${response.data[0]}/${response.data[1]}`;
        this.setState({ loading: false });
        window.location.replace(newRoute);
      })
      .catch(error => console.log(error));
  }
  
  imageUrlToFile = async (url, filename) => {
    const res = await fetch(url);
    const blob = await res.blob();
    return new File([blob], filename, { type: blob.type });
  }

  renderItems(arr, showControls) {
    let existingSpecimens = [];
    let unpackedReferences = [];
    arr.map(({id, idObv, idRev, imgType, name, year, page, number, geo, storage, weight, maxDiameter, copyright, indefinable}) => {
      if (existingSpecimens.indexOf(id) === -1) {
        existingSpecimens.push(id);
        unpackedReferences.push({id, idObv, idRev, imgType, geo, storage, weight, maxDiameter, copyright, indefinable, refs: [{id, name, year, page, number}]});
      } else {
        unpackedReferences.find(o => o.id === id)['refs'].push({id, name, year, page, number});
      }
    });

    const handleZoom = () => {
      document.querySelector('.zoomed-image-container').style.display = 'block';
    };

    return unpackedReferences.map(({id, idObv, idRev, imgType, refs, geo, storage, weight, maxDiameter, copyright, indefinable}) => {
        const path = `${this.stampsData._apiBase}specimens/${id}.${imgType}`;
        const image = (copyright && !localStorage.getItem("token")) ? null : 
        (<a href={path} target="_blank" data-zoompic>
            <img src={path} height="150" alt="Specimen" />
        </a>);
        const uniqueKey = `specimen${id}`;
        const inTypeLink = `${this.stampsData._clientBase}type/${idObv}/${idRev}/${id}`;
        const catNo = (<span className='cat-no'><a href={inTypeLink}>Specimen {id}</a></span>);
        let params = ` `;
        if (geo) params += `${geo}. `;
        if (storage) params += `Stored: ${storage}. `;
        if (weight) params += `Weight: ${weight} g. `;
        if (maxDiameter) params += `Diameter: ${maxDiameter} mm`;

        const handleCheckboxChange = (e) => {
          const checked = e.target.checked ? 1 : 0;
          this.stampsData.setIndefinable([id, checked]);
        };
        const indefinableSpecimen = (indefinable === 1);
        const isOwner = localStorage.getItem("token") && localStorage.getItem("user") === "dzmitry.huletski@gmail.com";

        return (
          <div key={uniqueKey} className="items-pad" id={uniqueKey}>
            {image}
            <div className="paddington">
              {catNo}
              {params}
            </div>
            <References onAdded={() => this.completeAdd()} refs={refs}/>
            { showControls && indefinableSpecimen ? (<span style={{color: 'lightcoral'}}><span className='no_svod'>!</span>  Атрибуция изображений или русское происхождение сомнительны<br/>
</span> ) : null}

            {showControls && isOwner && (
              <label>
                <input 
                  type="checkbox" 
                  defaultChecked={indefinable === 1} 
                  onChange={handleCheckboxChange} 
                />
                &nbsp;Set as indefinable
                <br />
                <a href='#' onClick={() => this.handleSplitAndSend(path, id)}>Allocate the new stamps</a>
                <br />
                <input
                  type="text"
                  placeholder="obvId/revId"
                />
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  const value = e.target.previousElementSibling?.value?.trim();
                  const match = value.match(/^(\d+)\/(\d+)$/);

                  if (!match) return;

                  const [, idObv, idRev] = match;

                  this.stampsData.moveToOtherType(id, idObv, idRev)
                    .then(() => window.location.reload())
                    .catch(error => console.error(error));
                }}> → Move to another type
                </a>
              </label> 
            )}
          </div>
        );
    });
  }

  completeAdd() {
    this.props.onAdded();
  }

  render() {
    const { items, showControls } = this.props;

    if (!items) {
      return (
        <Loading />
      )
    }
    return this.renderItems(items, showControls);
  }
}
